import Vue from 'vue';
import Component from 'vue-class-component';

import { Swiper, SwiperSlide, SwiperOptions, swiper } from '@/utils/swiperUtils';

@Component({
  components: {
    Swiper,
    SwiperSlide,
  },
})
export default class SwiperMixin extends Vue {
  $refs!: {
    swiper: swiper;
  };

  get swiper() {
    return (this.$refs.swiper as any)?.swiperInstance;
  }

  getSwiperByRef(ref: string) {
    return (this.$refs[ref] as any)?.swiperInstance;
  }
}
